package xyz.malefic.multipage.i18n

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember

val LocalLanguage = compositionLocalOf<MutableState<Language>> {
    error("No language state provided")
}

@Composable
fun LanguageProvider(content: @Composable () -> Unit) {
    val languageState = remember { mutableStateOf(Language.JA) }
    CompositionLocalProvider(LocalLanguage provides languageState) {
        content()
    }
}

@Composable
fun t(key: String): String {
    val lang = LocalLanguage.current.value
    return Strings.get(key, lang)
}
